var path = 'areas/projects/actions/docker_stop/Octopus.DockerStop_summary.html';
var html = "<p> Stop a Docker Resource <span ng-show=isSingleStep>on machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_stop/Octopus.DockerStop_summary.html
// module id = 881
// module chunks = 1